import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Command, StationItem } from './models/StationModel';
import { ComparableSensorWidget, SensorItem } from './models/SensorModel';
import { NearbyPlotItem } from './models/NearbyPlotModel';
import { SensorDataItem } from './models/SensorDataModel';

export default class IotVuexModule extends AbacoVuexModule {
    @State() currentStation!: StationItem;
    @State({ default: [] }) stations!: StationItem[];
    @State({ default: [] }) sensorData!: SensorDataItem[];
    @State({ default: [] }) nearbyPlots!: NearbyPlotItem[];
    @State({ default: [] }) disabledNearbyPlots!: NearbyPlotItem[];
    @State({ default: [] }) selectedNearbyPlots!: NearbyPlotItem[];
    @State({ default: new Map() }) selectedNearbyPlotsMap!: Map<number, NearbyPlotItem>;

    @State({ default: 0 }) triggerStationSelection!: number;
    @State({ default: 0 }) triggerStationsLoaded!: number;
    @State({ default: 0 }) triggerZoomOverStation!: number;
    @State({ default: 0 }) triggerNearbyPlotSelection!: number;
    @State({ default: 0 }) triggerZoomOverNearbyPlotsStation!: number;
    @State({ default: 0 }) triggerZoomOverSensorData!: number;
    @State({ default: 0 }) triggerHistoryCattlePrint!: number;
    @State({ default: 1000 }) filterNearbyPlotsDistance!: number;
    @State({ default: false }) plotHasValidityDate!: boolean;

    @State() currentSensorData!: SensorDataItem;
    @State() currentSensor!: SensorItem;
    @State() stationCommands!: Command[];
    @State({ default: [] }) sensors!: SensorItem[];

    @State() selectedImageFromHistory!: string;


    @State({ default: false }) loadingSensorHistoryData!: boolean;
    @State({ default: false }) loadingStations!: boolean;

    @State({ default: [] }) currentPosition!: number[];

    @State({ default: false }) hasPermissionToViewHivePosition!: boolean;

    @State() canEditIotConf!: boolean;

    @State() printableMap!: string;

    @State() deereConfigurable!: boolean;

    @State({default: {}}) comparableSensorWidgets!: Record<string, ComparableSensorWidget>

}
